"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveProvinceProducts = exports.storeProvinceProducts = exports.getProvinceProductsChangeSet = exports.uploadProvinceProductsCatalogue = exports.getProvinceProductsFromSignedUrl = exports.getProvinceProducts = void 0;
const shared_1 = require("@getgreenline/shared");
const setBaseUrl = (province) => `${shared_1.PROVINCE_PRODUCTS_API_URL}/${province}`;
const getProvinceProducts = (province, searchFields) => __awaiter(void 0, void 0, void 0, function* () {
    let url = setBaseUrl(province);
    if (searchFields) {
        url += `?searchQuery=${searchFields}`;
    }
    const res = yield shared_1.axios.get(url);
    return res.data.products;
});
exports.getProvinceProducts = getProvinceProducts;
const getProvinceProductsFromSignedUrl = (province, searchFields) => __awaiter(void 0, void 0, void 0, function* () {
    const searchParams = new URLSearchParams(searchFields === null || searchFields === void 0 ? void 0 : searchFields.map((field) => ['searchQuery', field])).toString();
    const searchQuery = searchParams && `?${searchParams}`;
    const url = `${setBaseUrl(province)}/signed-url${searchQuery}`;
    const { signedUrl } = (yield shared_1.axios.get(url)).data;
    const provinceProducts = (yield shared_1.axiosUnauthenticated.get(signedUrl))
        .data;
    return provinceProducts;
});
exports.getProvinceProductsFromSignedUrl = getProvinceProductsFromSignedUrl;
const uploadProvinceProductsCatalogue = (province, fileExtension, contentType) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.post(`${setBaseUrl(province)}/upload`, {
        fileExtension,
        contentType,
    });
    return res.data.signedUrl;
});
exports.uploadProvinceProductsCatalogue = uploadProvinceProductsCatalogue;
const getProvinceProductsChangeSet = (province, filename) => __awaiter(void 0, void 0, void 0, function* () {
    const { data: signedUrl } = yield shared_1.axios.get(`${setBaseUrl(province)}/filenames/${filename}`);
    const changeSet = yield shared_1.axiosUnauthenticated.get(signedUrl);
    return changeSet.data;
});
exports.getProvinceProductsChangeSet = getProvinceProductsChangeSet;
const storeProvinceProducts = (province, filename) => __awaiter(void 0, void 0, void 0, function* () {
    yield shared_1.axios.post(`${setBaseUrl(province)}/store`, { filename });
});
exports.storeProvinceProducts = storeProvinceProducts;
const saveProvinceProducts = (province, products) => __awaiter(void 0, void 0, void 0, function* () {
    yield shared_1.axios.post(`${setBaseUrl(province)}/products`, { products });
});
exports.saveProvinceProducts = saveProvinceProducts;
//# sourceMappingURL=provinceProducts.js.map